import { c as _c } from "react/compiler-runtime";
import { getLockedActionKeysForRow } from '../../types/ActionLockState';
import { selectActionLocks } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';

/**
 * Returns a Set of action keys that are currently locked for the given row.
 *
 * Subscribes to the `actionLocks` slice of the store.
 * Used by RowActions to determine per-button disabled state.
 */
export function useActionLocksForRow(rowId) {
  const $ = _c(3);
  const actionLocks = useEagGridSelector(selectActionLocks);
  let t0;
  if ($[0] !== actionLocks || $[1] !== rowId) {
    t0 = getLockedActionKeysForRow(actionLocks, rowId);
    $[0] = actionLocks;
    $[1] = rowId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}